"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.validateToken = exports.previousOperatorTakesPrecedent = exports.getValue = exports.newTokenGenerator = void 0;
var lex_1 = require("../lex/lex");
var types_1 = require("../types");
var const_1 = require("./const");
var newTokenGenerator = function (expression) {
    var remainingExpression = expression;
    return function (validTokens, endIsValid) {
        if (endIsValid === void 0) { endIsValid = false; }
        while (true) {
            var _a = (0, lex_1.lex)(remainingExpression), token = _a.token, remainingString = _a.remainingString;
            remainingExpression = remainingString;
            if (token.name !== types_1.Tokens.COMMENT) {
                (0, exports.validateToken)(token, validTokens, endIsValid);
                return token;
            }
        }
    };
};
exports.newTokenGenerator = newTokenGenerator;
var getValue = function (getNextToken, parser) {
    var nextToken = getNextToken(const_1.VALID_TOKENS.identifierOrNot);
    var negatedValue = nextToken.value === types_1.Operators.NOT;
    if (negatedValue) {
        nextToken = getNextToken(const_1.VALID_TOKENS.identifierOnly);
    }
    var value = nextToken.name === types_1.Tokens.STRUCTURAL_CHARACTER
        ? parser(getNextToken, true)
        : [nextToken];
    return negatedValue
        ? __spreadArray(__spreadArray([], value, true), [{ name: types_1.Tokens.OPERATOR, value: types_1.Operators.NOT }], false) : value;
};
exports.getValue = getValue;
var previousOperatorTakesPrecedent = function (previousOperator, nextOperator) {
    return const_1.OPERATOR_PRECEDENCE[previousOperator] <= const_1.OPERATOR_PRECEDENCE[nextOperator];
};
exports.previousOperatorTakesPrecedent = previousOperatorTakesPrecedent;
var validateToken = function (token, validTokens, endIsValid) {
    if (endIsValid === void 0) { endIsValid = false; }
    if (token.name === types_1.Tokens.EOF) {
        if (endIsValid) {
            return;
        }
        throw new Error('Unexpected end of expression');
    }
    for (var _i = 0, validTokens_1 = validTokens; _i < validTokens_1.length; _i++) {
        var validToken = validTokens_1[_i];
        if (validToken.name === token.name) {
            if (!validToken.value || validToken.value === token.value) {
                return;
            }
        }
    }
    throw new TypeError('Invalid token');
};
exports.validateToken = validateToken;
